<div class="payments" *ngIf="payment && payAllInvoices">
  <div class="options">
    <div class="title">{{ 'how_would_you_like_to_pay' | translate }}</div>
    <mat-radio-group [formControl]="selectedPaymentOption" class="radio-option">
      <mat-radio-button class="option" *ngFor="let payment_option of paymentOptions" [value]="payment_option.value">
        <div class="option-text">
          <div
            [innerHTML]="
              'pay_with'
                | translate
                  : { amount: (payment?.paymentAmount | currency: (currencyCode$ | async) : 'symbol-narrow'), option: payment_option.name }
            "
          ></div>
          <img src="{{ payment_option.logo }}" alt="{{ payment_option.name }}" />
        </div>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="continue-button">
    <button mat-flat-button (click)="location.back()" type="button">{{ 'back' | translate }}</button>
    <button mat-flat-button (click)="openPayment()" type="button" color="primary" [disabled]="!this.selectedPaymentOption.value">
      <mat-icon svgIcon="arrow-right"></mat-icon>
      {{ 'continue' | translate }}
    </button>
  </div>
  <div>
    <div class="view-payment">
      <gc-view-payment [payment]="selectedPayment" url="/payments"></gc-view-payment>
    </div>
  </div>
</div>
